module.exports = __webpack_public_path__ + "img/upper_cheeks.1d8fdaf1.svg";